// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { stepstone as baseStepstoneTheme } from "@stepstone-genesis/design-tokens";
var stepstone = extendBaseTheme("stepstone", baseStepstoneTheme);
export {
  stepstone
};
